import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Progress } from "antd"
import { createLLCBoxes } from '../../../services/api/apiNextBox'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

CreateMultiBoxLLC.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired
}

function CreateMultiBoxLLC(props) {
    const { visible, onCancel, selectedItems, setSelectedItems } = props
    const [loading, setLoading] = useState(false)
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])


    const _onChangeCreateBoxLLC = async (id) => {
        try {
            const payload = {
                llc_box_id: id,
            }

            const { data:response} = await createLLCBoxes(payload)

            const { success, message } = response

            if (!success) {
                return { success: success, message: message }
            }

            return { success: success }
        } catch (e) {
            return { success: false, message: e.message }
        }
    }

    const _onSubmitChange = async () => {
        setLoading(true)
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i=>{
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))

        let processed = []

        await Promise.all(selectedItems.map(async item => {
            const response = await _onChangeCreateBoxLLC(item._id)

            console.log(response)
            const { success, message } = response

            if (!success) return processed.push({ ...item, error: message, processing: false })

            return processed.push({ ...item, success: true, processing: false })
        }))

        let newListSuccess = []
        let newListError = []

        processed.map(process => {
            if (process.success === true) {
                return newListSuccess.push(process)
            }

            if (process.error.length > 0) {
                return newListError.push(process)
            }
        })

        setListSuccess(newListSuccess)
        setListError(newListError)
        setLoading(false)
        setSelectedItems(processed)
    }

    const handleCloseModal = () => {
        onCancel('isShowModal')
        setListSuccess([])
        setListError([])
        setSelectedItems(selectedItems.map(i=>{
            delete i.processing
            delete i.success
            delete i.error
            return i
        }))
    }

    return (
        <Modal
            className="CreateMultiBoxLLCModal"
            visible={visible}
            title="Tạo thùng LLC"
            onOk={_onSubmitChange}
            width='780px'
            onCancel={handleCloseModal}
            footer={[
                <Button key="back" disabled={loading} onClick={handleCloseModal}>
                    Cancel
                </Button>,
                <Button key="submit" disabled={loading|| (!!listSuccess.length || listError.length)}  type="primary" loading={loading} onClick={_onSubmitChange}>
                    Tạo thùng LLC
                </Button>
            ]}
        >
            <h3>List processing <span>{selectedItems.length}</span> items</h3>
            {
                (listSuccess.length > 0 || listError.length > 0) &&
                <div className="Results">
                    <div className="ResultSuccess">
                        Success: <span>{listSuccess.length}</span> items
                    </div>
                    <div className="ResultError">
                        Error: <span>{listError.length}</span> items
                    </div>
                </div>
            }

            <div className="ListProcessing">
                <ul>
                    {
                        !!selectedItems && selectedItems.length > 0 && selectedItems.map(item => (
                            <li key={item._id}>
                                <span className='font-weight-bold'>#{item.id}</span>
                                {
                                    !!item.error &&
                                    <span className="Error"><ExclamationCircleOutlined /> {item.error}</span>
                                }
                                {
                                    item.success &&
                                    <span className="Success"><CheckCircleOutlined /> Change success</span>
                                }
                                <Progress
                                    percent={(!!item.success || !!item.error) ? 100 : 0}
                                    size="small"
                                    status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && item.error.length > 0) ? 'exception' : 'active')}`}
                                    showInfo={false}
                                />
                            </li>
                        )
                        )
                    }
                </ul>
            </div>
        </Modal>
    )
}

export default CreateMultiBoxLLC
